export default "__VITE_ASSET__DtrGX3HY__";